import { render, staticRenderFns } from "./preformatted-editor-action-synoptic-templates.vue?vue&type=template&id=07e622de&scoped=true&"
import script from "./preformatted-editor-action-synoptic-templates.ts?vue&type=script&lang=ts&"
export * from "./preformatted-editor-action-synoptic-templates.ts?vue&type=script&lang=ts&"
import style0 from "./preformatted-editor-action-synoptic-templates.scss?vue&type=style&index=0&id=07e622de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e622de",
  null
  
)

export default component.exports